// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 7888) return "css/design_system-f5d7e715032522b8.css";
if (chunkId === 1710) return "css/1710-0573bf035ed5dce9.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {2059: "87ce88f17369403f",2429: "fb6768e074e958b7",2435: "2b9ae1178c35bc36",2447: "2b9ae1178c35bc36",3641: "91ecc8e70b90fc55",370: "a8d311b114ec77ce",3802: "fff606c4f8ef08bd",4278: "5e7c04a2b0740134",4926: "096c246142ab87bd",5222: "2b9ae1178c35bc36",}[chunkId] + ".css"
}